/**
 * Productos destacados de la portada, con la banda de quienes somos
 * (`PresentacionTienda`) metida a un tercio de la lista.
 *
 * El corte cae siempre en una fila entera de la grilla (`useColumnasGrilla`):
 * con 12 destacados y 4 columnas, 4 arriba y 8 abajo; con 100 y 6 columnas,
 * 36 arriba. Si no alcanzan para dos filas, la banda va despues de todos.
 *
 * La banda va de lado a lado, fuera del `.contenedor`: cada parte de la
 * grilla pone el suyo.
 *
 * La segunda parte lleva su propio `<h2>` oculto: sin el, sus tarjetas (`<h3>`)
 * quedarian bajo el `<h2>` de la banda.
 */
import type { FotoTienda, ProductoResumen } from '@elcarpintero/compartido';

import { useColumnasGrilla } from '../../hooks/use-columnas-grilla';
import { GrillaProductos } from '../catalogo/GrillaProductos';
import { PresentacionTienda } from './PresentacionTienda';
import { SeccionInicio } from './SeccionInicio';

/** Cuantos productos van antes de la banda: un tercio, en filas enteras. */
function corteDestacados(total: number, columnas: number): number {
  if (total < columnas * 2) return total;
  const filas = Math.max(1, Math.round(total / 3 / columnas));
  return Math.min(total, filas * columnas);
}

export interface SeccionDestacadosProps {
  productos: ProductoResumen[];
  bajada: string;
  fotoTienda: FotoTienda | null;
}

export function SeccionDestacados({ productos, bajada, fotoTienda }: SeccionDestacadosProps) {
  const [caja, columnas] = useColumnasGrilla<HTMLDivElement>();
  const corte = corteDestacados(productos.length, columnas);
  const resto = productos.slice(corte);

  return (
    <>
      <div className="contenedor">
        <SeccionInicio id="destacados" titulo="Lo que más sale del taller" bajada={bajada}>
          <div ref={caja}>
            <GrillaProductos productos={productos.slice(0, corte)} titulo="Productos destacados" />
          </div>
        </SeccionInicio>
      </div>

      <PresentacionTienda foto={fotoTienda} />

      {resto.length > 0 ? (
        <div className="contenedor seccion">
          <GrillaProductos productos={resto} titulo="Más productos destacados" titula />
        </div>
      ) : null}
    </>
  );
}
